import styled from 'styled-components';
import { Box } from '@material-ui/core';

const IndexStyled = styled(Box)`
  .store-info-box {
    .store-name {
      font-size: 26px;
      color: #212121;
    }
    .r1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 24px;

      & > div {
        flex: 1;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
      }
    }
    .divider {
      height: 86px;
      width: 0;
      margin: auto;
      border-left: 1px #ccc solid;
      border-right: 1px #ccc solid;
    }
  }

  .emp-search-box {
    .search-content {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      padding: 32px;

      & > div {
        flex: 1;
      }

      .left-words-box {
        margin-left: 26px;

        .word1 {
          line-height: 28px;
          font-size: 28px;
          color: #646464;
        }
        .word2 {
          font-size: 14px;
          color: #cccccc;
        }
      }
    }

    .button-group {
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      .reset {
        margin-right: 16px;
      }
      .search {
        margin-right: 0;
      }
    }
  }
`;
export default IndexStyled;
